export default __webpack_public_path__ + "static/R2-fc7034c77cc23a090f73a16d09786d64.png";